



















import { Component, Prop, Vue } from "vue-property-decorator";
import {AppealCustomFields} from "@/models/appeals";

@Component({
  computed: {
    hasMask() {
      return (this.item['маска'] || "") != "";
    }
  }
})
class LinkCustomField extends Vue {
  [x: string]: any;

  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: "" }) readonly fieldName!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: () => [] }) errorMessages: any;

  value = "";

  mounted() {
    this.value = this.item['значение'] || this.item['поУмолчанию'] || "";
    this.setValue();
  }

  setValue() {
    this.item['значение'] = this.value;
    this.item['ошибка'] = "";
  }

  /**
   * Валидация ссылки
   * @param v
   */
  isValidUrl(v) {
    const pattern = new RegExp(
      '^([a-zA-Z]+:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '(([\u0401\u0451\u0410-\u044f\\d]([\u0401\u0451\u0410-\u044f\\d-]*[\u0401\u0451\u0410-\u044f\\d])*)\\.)+рф|' + // domain name рф
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i'
    );
    return pattern.test(v);
  }


  /**
   * Валидация маски
   * @param v
   */
  isValidMask(v) {
    const mask = this.item['маска'].split('.').map(el => el.split('*').join('.+')).join('\\.') + '$';
    const pattern = new RegExp(mask, 'i');
    return pattern.test(v);
  }

  linkRule() {
    return [
      v => (!this.required && v == "") || this.isValidUrl(v) || "Некорректная ссылка",
      v => (!this.hasMask || v == "") || this.isValidMask(v) || "Некорректная маска (" + this.item['маска'] + ")",
    ];
  }
}

export default LinkCustomField;
